import React from 'react'
import { connect } from 'react-redux'
import { motion } from 'framer-motion'
import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { classNamesK } from '../../../lib/util'
import './Value.scss'

const ValueBox = styled(Box)(
  ({ theme }) => `
  .point {
    color: ${theme.palette.score.point};
  }

  .batsu {
    color: ${theme.palette.score.batsu};
  }

  .comp-point {
    color: ${theme.palette.score.compPoint};
  }
`
)

const Digit = ({ value, showScore }) => {
  const prev = React.useRef()

  React.useEffect(() => {
    prev.current = value
  }, [value])

  if (prev.current === undefined || value === prev.current) {
    return (
      <div className="value-box-internal">
        <Typography className={classNamesK('text', 'curr', { showScore })}>
          {value}
        </Typography>
      </div>
    )
  } else {
    const anime1 = value < prev.current ? [-48, 0] : [48, 0]
    const anime2 = value < prev.current ? [0, 48] : [0, -48]

    return (
      <>
        <motion.div className="value-box-internal"
                    key={value}
                    animate={{ top: anime1, transition: { duration: 0.4 } }}>
          <Typography className={classNamesK('text', 'curr', { showScore })}>
            {value}
          </Typography>
        </motion.div>
        <motion.div className="value-box-internal"
                    key={prev.current}
                    animate={{ top: anime2, transition: { duration: 0.4 } }}>
          <Typography className={classNamesK('text', 'prev', { showScore })}>
            {prev.current}
          </Typography>
        </motion.div>
      </>
    )
  }
}

const Value = ({ score, user, rule }) => {
  const showBatsu = rule.player.batsuWrong !== 0 || rule.player.specialWrong.swedish
  const showCompPoint = rule.player.comprehensive.active

  const text = {
    point: user.isMaster || rule.showScore ? score.point : '-',
    batsu: user.isMaster || rule.showScore ? score.batsu : '-',
    compPoint: user.isMaster || rule.showScore ? score.compPoint : '-'
  }

  const point = (
    <Box className="point value-box">
      <Digit value={text.point} showScore={rule.showScore} />
    </Box>
  )

  const batsu = (
    <Box className="batsu value-box">
      <Digit value={text.batsu} showScore={rule.showScore} />
    </Box>
  )

  const compPoint = (
    <Box className="comp-point value-box">
      <Digit value={text.compPoint} showScore={rule.showScore} />
    </Box>
  )

  return (
    <ValueBox className={classNamesK('value', { showBatsu, showCompPoint })}>
      {point}
      {showBatsu && showCompPoint && compPoint}
      {showBatsu && batsu}
    </ValueBox>
  )
}

export default connect(
  state => ({
    user: state.user,
    rule: state.rule
  })
)(Value)
